// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2qbKE","fileBtn":"File_fileBtn__2MVsU","closeBtn":"File_closeBtn__32CIU","fileSelected":"File_fileSelected__2ug4w","disabled":"File_disabled__2jb0M"};